import { useMemo } from 'react';
import { useData } from '../contexts/index';
import { useDataSync, usePlaysForViewer, useRoleCollection } from './index';
import {
  buildListerAgreement,
  buildRunnerAgreement,
  resolveStaffProfile,
  supportsStaffAgreements,
} from '../core/rules/staffAgreements';
import { ROLES } from '../core/constants/roles';

import type { AppUser } from '../types';
import type { StaffProfile } from '../core/rules/staffAgreements';

export function useStaffAgreement(viewer: AppUser | null | undefined) {
  const { adapter } = useData();
  const staffUsers = useDataSync<StaffProfile[]>(adapter, 'users', []);
  const plays = usePlaysForViewer(viewer);
  const stops = useRoleCollection('routeStops', []);

  return useMemo(() => {
    if (!viewer || !supportsStaffAgreements(viewer.role)) return null;

    const profile = resolveStaffProfile(viewer, staffUsers);

    if (viewer.role === ROLES.LISTER) {
      return buildListerAgreement(viewer, profile, plays);
    }
    if (viewer.role === ROLES.RUNNER) {
      return buildRunnerAgreement(viewer, profile, stops);
    }
    return null;
  }, [viewer, staffUsers, plays, stops]);
}
